module.exports = __webpack_public_path__ + "static/culture.vision-207606d9bef649ebc7b88aba016f0c7b.png";